import React from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";
import Ken from "../../../assets/shortlist_23/ken.png";
import Chukwumerije from "../../../assets/shortlist_23/chukwu.png";
import Olumide from "../../../assets/shortlist_23/olumide.png";
import Boniface from "../../../assets/shortlist_23/boniface.png";

const climateNominees = [
  {
    name: "Ken Henshaw",
    title: "We The People (WTP)",
    imgpath: Ken,
  },
  {
    name: "Prof. Chukwumerije Okereke",
    title: "Centre for Climate Change and Development",
    imgpath: Chukwumerije,
  },
  {
    name: "Olumide Idowu",
    title: "Climate Wednesday",
    imgpath: Olumide,
  },
  {
    name: "Lauritta Boniface",
    title: " Ecocykle",
    imgpath: Boniface,
  },
];

const ClimateNominees = () => {
  return (
    <Grid
      item
      xs={12}
      md={12}
      marginTop={{ xs: "10%", sm: "3%" }}
      data-aos={"fade-up"}
    >
      <Typography
        variant={"h5"}
        fontWeight={400}
        paddingBottom={"2%"}
        color={"#049593"}
      >
        Award for Climate Change Activism (Shortlisted Nominees)
      </Typography>
      <Grid item xs={12} md={12} display={"flex"} flexWrap={"wrap"}>
        {climateNominees.map((nominate, index) => {
          const { name, title, imgpath } = nominate;
          return (
            <Grid
              key={index}
              item
              xs={12}
              md={3}
              marginBottom={{ xs: "7%", sm: "2%" }}
            >
              <Card
                sx={{
                  maxWidth: 260,
                  height: "100%",
                  borderTop: "10px solid #D7A036",
                }}
              >
                <CardActionArea>
                  <CardContent>
                    <Avatar
                      alt={name}
                      src={imgpath}
                      sx={{ width: 126, height: 126 }}
                    />
                    <Typography
                      gutterBottom
                      variant="h6"
                      color={"#004165"}
                      component="div"
                      textAlign={"center"}
                    >
                      {name}
                    </Typography>
                    <Typography
                      variant="body2"
                      fontWeight={700}
                      color="#049593"
                      paragraph
                      textAlign={"center"}
                    >
                      {title}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default ClimateNominees;
